import { useTenantApi } from '@/hooks/useTenantApi';
import { isSaturday } from 'date-fns';
import { useEffect, useState } from 'react';
import '../../../pages/MyAlertsPage/MyAlertsPage.scss';
import '../../../views/MyAlerts/WeeklyAlerts.scss';
import { formatDateMMDDYYYY } from '../utils/alertUtil2_0';
import { ByzzerMask } from '@/components/ByzzerMask/ByzzerMask';
import { AlertViewActions } from '../utils/helpers';
import { ShadowContentRenderer } from '@/components/ShadowContentRenderer';
import { useLocation, useSearchParams } from 'react-router-dom';
import { DOMPurify, useBetterNavigate } from '@/utils';
import { DashboardContent } from '@/components/dashboard';

type CreatedBy = {
    fullName: string;
    email: string;
};

function MyAlertView2_0({}) {
    const { getAlertDetails } = useTenantApi();
    const [searchParams] = useSearchParams();
    const alertId = searchParams.get('alertId');
    const navigate = useBetterNavigate();

    const [alertTemplate, setAlertTemplate] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const [title, setTitle] = useState<string>('');
    const [createdBy, setCreatedBy] = useState<CreatedBy>({} as CreatedBy);
    const [duration, setDuration] = useState();
    const { key } = useLocation();

    useEffect(() => {
        getAlertData();
    }, [alertId]);

    async function getAlertData() {
        setLoading(true);
        let fetchedData = await getAlertDetails(alertId); // to fetch this alert ID's alert
        if (fetchedData.status === 'error') {
            navigateBack();
            return
        }
        const alertDetails = fetchedData?.alert?.result;
        // Sanitize the fetched HTML before setting state
        const sanitizedHtml = DOMPurify.sanitize(alertDetails?.html_for_ui?.string);
        let dt = new Date(alertDetails?.filter_duration.split('to')[1].trim());
        let filterDuration;

        if (!isSaturday(dt)) {
            filterDuration = formatDateMMDDYYYY(dt.setDate(dt.getDate() - 1));
        } else {
            filterDuration = formatDateMMDDYYYY(dt);
        }

        setAlertTemplate(sanitizedHtml);
        setTitle(alertDetails?.title);
        setDuration(filterDuration);
        setCreatedBy(fetchedData.alert?.createdBy);
        setLoading(false);
    }

    const showCreatedBy = Boolean(createdBy?.fullName && createdBy?.email);

    function navigateBack() {
        key !== 'default' ? navigate(-1) : navigate(`/dashboard/my_alerts/weekly`);
    }
    return (
        <DashboardContent
            title={title}
            subTitle={
                !loading && (
                    <div className="my-alerts__sub-heading">
                        <span>For the latest week, ending {duration}</span>
                        {showCreatedBy && (
                            <span>
                                Created by {createdBy?.fullName} ({createdBy?.email})
                            </span>
                        )}
                    </div>
                )
            }
            extras={<AlertViewActions goBack={()=>navigateBack()} />}
        >
            <ByzzerMask loading={loading} />

            <div className="detailed_card detailed_card_scroll detailed_card-view">
                {/* RENDERING ALERT TEMPLATE ------------- */}
                <ShadowContentRenderer htmlContent={alertTemplate} />
            </div>
        </DashboardContent>
    );
}

export default MyAlertView2_0;
